import { filter, isEmpty } from "lodash";
import PaymentDto from "../../PaymentContainerClient/dtos/PaymentDto";
import PaymentPlanDto from "../../PaymentContainerClient/dtos/PaymentPlanDto";
import getPaymentPlansWithAtLeastOnePaidOrScheduledOrOnHoldPayment from "./getPaymentPlansWithAtLeastOnePaidOrScheduledOrOnHoldPayment";
import getPaymentsSortedByCreatedAt, {
    PaymentCreatedAtSortDirection,
} from "./getPaymentsSortedByCreatedAt";

export default function getPaymentPlansMeaningfullForErrors(
    paymentPlans: PaymentPlanDto[],
    payments: PaymentDto[]
): PaymentPlanDto[] {
    const paymentPlansWithAtLeastOnePaidOrScheduledOrOnHoldPayment =
        getPaymentPlansWithAtLeastOnePaidOrScheduledOrOnHoldPayment(
            paymentPlans,
            payments
        );

    const lastPayment = getPaymentsSortedByCreatedAt(
        payments,
        PaymentCreatedAtSortDirection.Desc
    );

    return !isEmpty(paymentPlansWithAtLeastOnePaidOrScheduledOrOnHoldPayment)
        ? paymentPlansWithAtLeastOnePaidOrScheduledOrOnHoldPayment
        : !isEmpty(lastPayment)
        ? filter(paymentPlans, {
              id: lastPayment[0].paymentPlanId,
          })
        : paymentPlans;
}
